import { useMemo } from 'react';
import type { Bond } from '../../types/bonds';

interface BondTypeTabsProps {
  bonds: Bond[] | undefined;
  selectedType: string;
  onTypeChange: (type: string) => void;
}

export default function BondTypeTabs({ bonds, selectedType, onTypeChange }: BondTypeTabsProps) {
  // Get unique bond types
  const bondTypes = useMemo(() => {
    if (!bonds || !Array.isArray(bonds)) return [];
    const types = [...new Set(bonds.map(bond => bond.type))];
    return types.sort();
  }, [bonds]);

  // Jeśli nie ma żadnych typów, wyświetl komunikat
  if (bondTypes.length === 0) {
    return (
      <div className="bond-type-tabs">
        <div className="no-bonds-message">
          Brak obligacji do wyświetlenia. Dodaj nową obligację, aby rozpocząć.
        </div>
      </div>
    );
  }

  return (
    <div className="bond-type-tabs">
      {bondTypes.map(type => (
        <button
          key={type}
          className={`bond-type-tab${selectedType === type ? ' active' : ''}`}
          onClick={() => onTypeChange(type)}
        >
          {type} ({bonds?.filter(bond => bond.type === type).length || 0})
        </button>
      ))}
    </div>
  );
} 